var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.356 18.835c1.1092 1.4822 1.805 3.2992 1.9064 5.2873 0.2727 5.3288-3.8269 9.8679-9.1546 10.141-5.3287 0.2726-9.8679-3.827-10.14-9.1546-0.2727-5.3288 3.827-9.8679 9.1546-10.141 1.2389-0.0632 2.4343 0.1102 3.5445 0.4788m6.102 19.381 3.2075 6.9287-4.766-1.0383-2.3317 4.3243-3.1181-6.7346m-11.301-3.4801-3.2075 6.9287 4.767-1.0383 2.3318 4.3243 2.2772-4.9198m16.6-15.509c0 7.5189-6.0953 13.614-13.614 13.614-7.5188 0-13.614-6.0953-13.614-13.614 0-7.5188 6.0953-13.614 13.614-13.614 7.5189 0 13.614 6.0953 13.614 13.614zm-13.318-6.6963 1.5824 3.9752 4.2698 0.276c0.2879 0.0185 0.4057 0.3795 0.1832 0.5638l-3.2925 2.7331 1.0568 4.1465c0.0709 0.2792-0.2356 0.5028-0.4799 0.349l-3.6165-2.2859-3.6165 2.2859c-0.2443 0.1538-0.5507-0.0687-0.4798-0.349l1.0568-4.1465-3.2926-2.7331c-0.2225-0.1843-0.1047-0.5453 0.1832-0.5638l4.2698-0.276 1.5825-3.9752c0.1068-0.2683 0.4864-0.2683 0.5933 0z",
    stroke: "#878686",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotions);
export default __webpack_public_path__ + "static/media/promotions.26e161530875a10d2b589f5edc040bfd.svg";
export { ForwardRef as ReactComponent };